import moment from 'moment';
import 'moment-timezone';
import { payRateTypeObj, shiftTypeObj } from '../../helpers/data';
const login = JSON.parse(sessionStorage.getItem('login'));

export function transformUserDataFormat(storedData) {
  let retData = [];
  storedData.forEach((item) => {
    retData.push({
      employerUserId: item.id,
    });
  });
  return retData;
}

export function transformLanguagesSpokenFormat(storedData, storedOtherData) {
  let retData = [];
  storedData.forEach((item) => {
    if (item.name !== '') {
      retData.push({
        spokenLanguage: item.id,
        isOther: false,
        otherSpokenLanguage: '',
        mandatory: item.mandatory,
      });
    }
  });
  storedOtherData.forEach((item) => {
    if (item !== '') {
      retData.push({
        spokenLanguage: null,
        isOther: true,
        otherSpokenLanguage: item,
        mandatory: false,
      });
    }
  });
  return retData;
}

export function transformCertEMRDataFormat(storedData, storedOtherData) {
  let retData = [];
  // console.log(storedData);
  // console.log(storedOtherData);
  storedData.forEach((item) => {
    if (item.name !== '') {
      retData.push({
        id: item.id,
        isOther: false,
        otherName: '',
        mandatory: item.mandatory,
      });
    }
  });
  storedOtherData.forEach((item) => {
    if (item.name !== '') {
      retData.push({
        id: null,
        isOther: true,
        otherName: item.name,
        mandatory: item.mandatory,
      });
    }
  });
  return retData;
}
export function transformUserDatacovidVaccinationStatus(storedData) {
  let retData = [];
  storedData.forEach((item) => {
    retData.push(item.id);
  });
  return retData;
}
export function saveJobOpportunity(
  jobType,
  startJob,
  location,
  shift,
  jobInfo,
  education,
  medicalSpeciality,
  certification,
  emrEhrSystemExperience,
  covidVaccinationStatus,
  templateInfo,
  employerId,
  loadJobId,
  saveType,
  filterJobList,
  formdata,
  recursionFlag,
  rrurle,
  jobMultishiftOccurreneUpdateList,
  JobEncounterOccurreneUpdateList,
  masterData,
  encounterCalculation,
  isAutoPostAllowed,
  isOvertimeAllowed,
  depsUnits,
  payRateType,
  payRateTotalShiftAmount,
  payRateOccurrenceAmount
) {
  console.log({ depsUnits });
  // console.log(JobEncounterOccurreneUpdateList);
  let newdate = '';
  let jobid = '';
  let domainid = '';
  if (JobEncounterOccurreneUpdateList?.length) {
    // console.log('---', JobEncounterOccurreneUpdateList[0].Start);
    // console.log(moment(JobEncounterOccurreneUpdateList[0].Start).format('YYYY-MM-DD'));
    newdate = moment(JobEncounterOccurreneUpdateList[0].Start).format(
      'YYYY-MM-DD'
    );
  }
  if (masterData?.allJobDomains?.length) {
    domainid = masterData?.allJobDomains[0].id;
  }
  if (masterData?.allJobTypes?.length) {
    jobid = masterData?.allJobTypes[0].id;
  }

  console.log(jobMultishiftOccurreneUpdateList, '===========');

  return {
    createJobOpportunity: saveType,
    locationId: location.locationNameInfo.id,
    jobDomainId: jobType.domain.id ? jobType.domain.id : domainid,
    jobTypeID: jobType.type.id ? jobType.type.id : jobid,
    jobDate: shift.date ? shift.date : newdate ? newdate : '',
    singleShiftEndDate:(+recursionFlag === shiftTypeObj.singleShift) ?  shift?.singleShiftEndDate : null,
    shiftStartTime: shift.startTime?.name ? shift.startTime?.name : '',
    shiftEndTime: shift.endTime?.name ? shift.endTime?.name : '',
    shiftHours: shift?.preferedShift?.id,
    jobCategoryId: jobInfo.jobCategory.id,
    jobTitle: jobInfo.jobTitle,
    jobDescription: jobInfo.jobDescription,
    Incentive: parseFloat(jobInfo.incentive) ?? null,
    RatePerHour: jobInfo.ratePerHour,
    // HourlyBillingRate: jobInfo?.billingrate,
    // HourlyBillingRate: parseInt(recursionFlag) === 1 ? jobInfo?.shiftamount?.toString() : jobInfo?.billingrate?.toString(),
    HourlyBillingRate: null,
    levelOfEducation: (education.level && education.level.id) ? education.level.id : 0,
    jobTemplateId: startJob.templateID.id,
    jobsCovid19VaccinatedList: transformUserDatacovidVaccinationStatus(
      covidVaccinationStatus
    ),
    jobTemplateName: templateInfo.name,
    templateType: templateInfo.option,
    jobsContactsList: transformUserDataFormat(location.contactPersons),
    jobsApproversList: transformUserDataFormat(location.approvalUsers),
    jobsCertificationsList: filterJobList?.showCertifications
      ? transformCertEMRDataFormat(
        certification.definedCertification,
        certification.otherCertification
      )
      : [],
    jobsEMREHRSystemsList: filterJobList?.showEmr
      ? transformCertEMRDataFormat(
        emrEhrSystemExperience.definedExperience,
        emrEhrSystemExperience.otherExperience
      )
      : [],
    jobsSpecialtiesList: filterJobList?.showSpecialties
      ? medicalSpeciality.speciality?.map((item) => ({
        specialtyId: item?.specialtyId || item?.id,
        yearsOfExperience: item?.yearsOfExperience,
        isOther: false,
        otherName: '',
        mandatory: item?.mandatory,
      }))
      : [],
    jobsSpokenLanguagesList: transformLanguagesSpokenFormat(
      education.languageSpoken,
      education.otherLanguagesSpoken
    ),
    jobsProfileFormsList: transDynamicFormData(formdata),
    mainShiftType: recursionFlag,
    jobEndDate: shift.endDate
      ? shift.endDate
      : shift.date
        ? shift.date
        : newdate
          ? newdate
          : null,
    jobsMultiShifts: {
      shiftType: recursionFlag,
      recurrenceRule: rrurle,
      recurrenceException: '',
      jobEndDate: shift.endDate ? shift.endDate : null,
    },
    jobMultishiftOccurreneUpdateList:
      jobMultishiftOccurreneUpdateList &&
        jobMultishiftOccurreneUpdateList.length &&
        recursionFlag?.toString() === '3'
        ? jobMultishiftOccurreneUpdateList.map((element, index) => {
          return {
            ownerID: element.ownerID,
            taskID: typeof element.TaskID === 'number' ? element.TaskID : 0,
            title: element.Title,
            description: element.Description,
            startTime: moment(element.Start).format('h:mm A'),
            endTime: moment(element.End).format('h:mm A'),
            // start: moment.tz(fromDate, login?.timeZoneShort).utc().format(),
            // end: moment.tz(toDate, login?.timeZoneShort).utc().format(),
            start: moment(element.Start).utc().format(),
            end: moment(element.End).utc().format(),
            StartText: moment(element.Start).format('YYYY-MM-DDTHH:mm:ss'),
            EndText: moment(element.End).format('YYYY-MM-DDTHH:mm:ss'),
            recurrenceRule: element.RecurrenceRule,
            recurrenceException:
              element.RecurrenceException &&
                element.RecurrenceException.length
                ? element.RecurrenceException.map((dateElement, index) => {
                  return moment
                    .tz(dateElement, login?.timeZoneShort)
                    .utc()
                    .format();
                })
                : element.RecurrenceException,
                recurrenceException_foreditDate:
              element.RecurrenceException &&
                element.RecurrenceException.length
                ? element.RecurrenceException.map((dateElement, index) => {
                  return moment(dateElement).format('YYYY-MM-DDTHH:mm:ss');
                })
                : element.RecurrenceException,
            recurrenceID: !element.RecurrenceID
              ? element.RecurrenceID
              : typeof element.RecurrenceID === 'number'
                ? element.RecurrenceID
                : 0,
            isAllDay: element.isAllDay,
            editDay: element.editDay,
            jobsContactsList: element?.jobsContactsList,
            jobsApproversList: element?.jobsApproversList,
            billingrate: null, //  element?.billingrate?.toString()
            shiftLength: element.shiftLength,
            locationId: element?.locationId,
            manualAmountPerShift: element?.payRateOccurrenceAmount ? element?.payRateOccurrenceAmount : null
          };
        })
        : [],
    OccurrenesJson:
      jobMultishiftOccurreneUpdateList &&
        jobMultishiftOccurreneUpdateList.length &&
        recursionFlag?.toString() === '3'
        ? jobMultishiftOccurreneUpdateList.map((element, index) => {
          return {
            ownerID: element.ownerID,
            taskID: element.TaskID,
            title: element.Title,
            description: element.Description,
            startTime: moment(element.Start).format('h:mm A'),
            endTime: moment(element.End).format('h:mm A'),
            start: moment(element.Start).utc().format(),
            end: moment(element.End).utc().format(),
            recurrenceRule: element.RecurrenceRule,
            recurrenceException:
              element.RecurrenceException &&
                element.RecurrenceException.length
                ? element.RecurrenceException.map((dateElement, index) => {
                  return moment(dateElement).utc().format();
                })
                : element.RecurrenceException,
            recurrenceID: !element.RecurrenceID
              ? element.RecurrenceID
              : typeof element.RecurrenceID === 'number'
                ? element.RecurrenceID
                : 0,
            isAllDay: element.isAllDay,
            editDay: element.editDay,
            jobsContactsList: element?.jobsContactsList,
            jobsApproversList: element?.jobsApproversList,
            billingrate: null, // element?.billingrate?.toString()
            shiftLength: element.shiftLength,
            locationId: element?.locationId,
            manualAmountPerShift: element?.payRateOccurrenceAmount ? element?.payRateOccurrenceAmount : null
          };
        })
        : [],
    JobEncounterOccurreneUpdateList:
      JobEncounterOccurreneUpdateList &&
        JobEncounterOccurreneUpdateList.length &&
        recursionFlag?.toString() === '2'
        ? JobEncounterOccurreneUpdateList.map((element, index) => {
          return {
            // taskID: typeof element.TaskID === 'number' ? element.TaskID : 0,
            // title: element.Title ? element.Title : '',
            taskID: element.TaskID ? element.TaskID.toString() : "0",
            start: moment(element.Start).utc().format(),
            end: moment(element.End).utc().format(),
            isAllDay: element.isAllDay,
            appointmentType: element.AppointmentType,
            shiftLength: element.ShiftLength,
            patientName: element.PatientName,
            patientPhone: element.PatientPhone,
            patientStreetAddress: element.PatientStreetAddress,
            patientZipCode: element.PatientZipCode,
            PatientState: element.PatientState,
            PatientCity: element.PatientCity,
            StartText: moment(element.Start).format('YYYY-MM-DDTHH:mm:ss'),
            EndText: moment(element.End).format('YYYY-MM-DDTHH:mm:ss'),
            billingRate: element.billingRate,
            jobsClaimId: element.jobsClaimId ? element.jobsClaimId : 0,
            candidateUniqueId: element?.candidateUniqueId,
            isClaimed: element?.IsClaimed ? element?.IsClaimed : false,
            shiftUniqueId: element?.ShiftUniqueId ? element?.ShiftUniqueId : "",
            title: "",
            isCheckedIn: element?.isCheckedIn ? element?.isCheckedIn : false,
            isCheckedOut: element?.isCheckedOut ? element?.isCheckedOut : false,
            isNewSlot: element?.isNewSlot
            // mapDetails: element.MapDetails,
          };
        })
        : [],
    encounterOccurrenceJson:
      JobEncounterOccurreneUpdateList &&
        JobEncounterOccurreneUpdateList.length &&
        recursionFlag?.toString() === '2'
        ? JobEncounterOccurreneUpdateList.map((element, index) => {
          return {
            taskID: element.TaskID,
            // title: element.Title ? element.Title : '',
            start: moment(element.Start).utc().format(),
            end: moment(element.End).utc().format(),
            isAllDay: element.isAllDay,
            appointmentType: element.AppointmentType,
            shiftLength: element.ShiftLength,
            patientName: element.PatientName,
            patientPhone: element.PatientPhone,
            patientStreetAddress: element.PatientStreetAddress,
            patientZipCode: element.PatientZipCode,
            PatientState: element.PatientState,
            PatientCity: element.PatientCity,
            billingRate: element.billingRate,
            jobsClaimId: element.jobsClaimId ? element.jobsClaimId : 0,
            candidateUniqueId: element?.candidateUniqueId,
            isClaimed: element?.IsClaimed ? element?.IsClaimed : false,
            shiftUniqueId: element?.ShiftUniqueId ? element?.ShiftUniqueId : "",
            title: "",
            isCheckedIn: element?.isCheckedIn ? element?.isCheckedIn : false,
            isCheckedOut: element?.isCheckedOut ? element?.isCheckedOut : false,
            isNewSlot: element?.isNewSlot
            // mapDetails: element.MapDetails,
          };
        })
        : [],
    candidatesShiftIncentives: encounterCalculation && encounterCalculation?.length > 0 && recursionFlag?.toString() === '2' ? encounterCalculation : [],
    isAutoPostAllowed: isAutoPostAllowed ? true : false,
    isOvertimeAllowed: (isOvertimeAllowed || (+payRateType === payRateTypeObj.manualCal)) ? true : false,
    candidateDepartmentId: depsUnits?.id,
    DepartmentName: depsUnits?.name,
    payRateType: payRateType ?? null,
    manualTotalShiftAmount: (+payRateType === payRateTypeObj?.manualCal) ? payRateTotalShiftAmount : null,
    manualAmountPerShift: ((+payRateType === payRateTypeObj?.manualCal) && (+recursionFlag === shiftTypeObj.multiShift)) ? payRateOccurrenceAmount : null
    // depsUnits?.length ? 
    // depsUnits.map(deps => ({"candidateDepartmentId":depsUnits?.id,"name":deps?.name})) 
    // :[]
  };
}
// transDynamicFormData(formdata)
export function transDynamicFormData(formdata) {
  const newVal = JSON.parse(JSON.stringify(formdata));
  const formatVal = [];
  newVal.forEach((item) => {
    const info = [];
    item?.controlsInfo.forEach((val) => {
      info.push({
        formSectionId: val.formsSectionID,
        formControlId: val.formsControlId,
        controlType: val.controlType,
        isMultiple: val.isMultiple,
        selectedValue: val.selectedValueOptions?.length
          ? val.selectedValueOptions.map((item) => item.id)
          : [],
      });
    });
    formatVal.push({
      formId: item.formId,
      jobProfileSections: info,
    });
  });
  return formatVal;
}

export function validateJobType(jobType, errors, masterData) {
  // console.log({jobType, errors,masterData});
  if (masterData?.allJobTypes.length > 1) {
    if (!jobType.domain.id) {
      errors['domain'] = ['Select the Job domain.'];
    }
    if (!jobType.type.id) {
      errors['type'] = ['Select the Job type.'];
    }
  }
}

export function validateStartJob(selectedOption, startJob, errors) {
  if (selectedOption.fromTemplate && startJob.templateID === '') {
    errors['startJobTemplate'] = ['Select a job template.'];
  }
}

export function validateLocationInfo(location, errors) {
  if (!location.locationNameInfo || location?.locationNameInfo.id === '') {
    errors['locationNameInfo'] = ['Select a Location.'];
  }
  if (location?.contactPersons.length === 0) {
    errors['contactPersons'] = ['Select a Contact Person.'];
  }
  if (location?.approvalUsers.length === 0) {
    errors['approvalUsers'] = ['Select a Approval User.'];
  }
}

export function validateShiftInfo(shift, errors, recursionFlag, selectedAuthUsers, JobEncounterOccurreneUpdateList) {
  if (parseInt(recursionFlag) !== 2) {
    if (
      !shift.startTime ||
      shift?.startTime === '' ||
      shift?.startTime === 'Select'
    ) {
      errors['startTime'] = ['Select start time.'];
    }
  }
  if (parseInt(recursionFlag) !== 2) {
    if (
      !shift.endTime ||
      shift?.endTime === '' ||
      shift?.endTime === 'Select'
    ) {
      errors['endTime'] = ['Select end time.'];
    }
  }

  var startTime = new Date(Date.parse(shift?.date + ' ' + shift?.startTime));
  var endTime = new Date(Date.parse(shift?.date + ' ' + shift?.endTime));
  if (parseInt(recursionFlag) !== 2) {
    if (startTime >= endTime) {
      errors['endTime'] = ['End time must be greater than start time.'];
    }
  }

  if (parseInt(recursionFlag) !== 2) {
    if (!shift.preferedShift || shift?.preferedShift === '') {
      errors['preferedShift'] = ['Select prefered Shift.'];
    }
  }
  if (parseInt(recursionFlag) !== 2) {
    if (shift?.date === '') {
      errors['shiftDate'] = ['Select shift date.'];
    }
  }

  if (recursionFlag?.toString() === '3') {
    if (
      !shift.endDate ||
      shift?.endDate === '' ||
      shift?.endDate === 'Select'
    ) {
      errors['endDate'] = ['Select End Date.'];
    }
  }
  if (parseInt(recursionFlag) === 2) {
    if (!selectedAuthUsers?.length) {
      errors['authorizedUser'] = ['Select authorized user']
    }
    if (!JobEncounterOccurreneUpdateList?.length) {
      errors['encounterList'] = ['Create shift on calendar']
    }
  }
}

export function validateJobInfo(jobInfo, errors, recursionFlag) {
  if (
    jobInfo?.jobTemplate === '' ||
    jobInfo?.jobTemplate === 'Select' ||
    !jobInfo?.jobTemplate
  ) {
    errors['jobTemplate'] = ['Select a job template.'];
  }
  if (
    jobInfo?.jobCategory === '' ||
    jobInfo?.jobCategory === 'Select' ||
    !jobInfo?.jobCategory
  ) {
    errors['jobCategory'] = ['Select a job category.'];
  }
  // if (parseInt(recursionFlag) !== 2) {
  //   if (
  //     jobInfo?.billingrate === '' ||
  //     jobInfo?.billingrate === 0 || !jobInfo?.billingrate
  //   ) {
  //     console.log();
  //     errors['billingrate'] = ['This field required'];
  //   }
  // }

  if (jobInfo?.jobTitle === '' || !jobInfo?.jobTitle) {
    errors['jobTitle'] = ['Enter job title.'];
  }
  // if (jobInfo?.jobDescription === '') {
  //     errors["jobDescription"] = ["Enter job description."];
  // }
}

export function validateEducationInfo(education, errors) {
  if (!education.level || education?.level === '') {
    errors['educationLevel'] = ['Select education level.'];
  }
  // const languageError = [];
  // education?.languageSpoken.forEach((item, index) => {
  //   if (item === undefined || item?.name === '') {
  //     languageError[index] = ['Select a language spoken'];
  //   }
  // });
  // if (education?.languageSpoken.length === 0) {
  //   languageError.push(['Select a language spoken']);
  // }
  // errors['languagesSpoken'] =
  //   languageError.length > 0 ? languageError : undefined;
  // console.log(errors);
  // if (
  //   education?.otherLanguagesSpoken?.filter((otherLng) => otherLng !== '')
  //     ?.length > 0
  // ) {
  //   errors['languagesSpoken'] = undefined;
  // }
}

export function validateMedicalSpecialityInfo(medicalSpeciality, errors) {
  const specialityError = [];
  medicalSpeciality?.speciality.forEach((item, index) => {
    if (item === undefined || item?.name === '') {
      specialityError[index] = ['Select a Speciality'];
    }
  });
  if (medicalSpeciality?.speciality.length === 0) {
    specialityError.push(['Select a Speciality']);
  }
  errors['speciality'] =
    specialityError.length > 0 ? specialityError : undefined;
}

export function validateCertificationInfo(certification, errors) {
  const certError = [];
  certification?.definedCertification.forEach((item, index) => {
    if (item === undefined || item?.name === '') {
      certError[index] = ['Select a Certification'];
    }
  });
  if (certification?.definedCertification.length === 0) {
    certError.push(['Select a Certification']);
  }
  errors['definedCertification'] = certError.length > 0 ? certError : undefined;
}

export function validateEMREHRInfo(emrEhrSystemExperience, errors) {
  const emrError = [];
  emrEhrSystemExperience?.definedExperience.forEach((item, index) => {
    if (item === undefined || item?.name === '') {
      emrError[index] = ['Select an experience'];
    }
  });
  if (emrEhrSystemExperience?.definedExperience.length === 0) {
    emrError.push(['Select an experience']);
  }
  errors['definedExperience'] = emrError.length > 0 ? emrError : undefined;
}

export function validateCovidInfo(covidVaccinationStatus, errors) {
  if (covidVaccinationStatus?.name === 'Select') {
    errors['covidVaccinationStatus'] = ['Select a value.'];
  }
}
export function validateOvetimeAllowed(isOvertimeAllowed, errors, selectedOption, recursionFlag) {
  if ((!selectedOption?.createTemplate) && isOvertimeAllowed === null || isOvertimeAllowed === undefined) {
    if (parseInt(recursionFlag) !== 2) {
      errors['isOvertimeAllowed'] = ['Select a value.'];
    }
  }
}
export function validateDepsUnits(depsUnits, errors) {
  if (depsUnits.length === 0) {
    errors['depsUnits'] = ['Select a value.'];
  }
}

export function validateTemplateInfo(templateInfo, errors, selectedOption) {
  if (templateInfo?.option === 1 && templateInfo?.name === '') {
    errors['templateName'] = ['Enter template name.'];
  }
  if (selectedOption.fromTemplate) {
    if (templateInfo?.option === '') {
      errors['templateIntoType'] = ['Choose template action.'];
    }
  }
}

export const validatDynamicForm = (data, errors, inputTypes) => {
  const newerrors = {};
  let valid = false;
  data.forEach((item) => {
    item.controlsInfo.forEach((val) => {
      if (inputTypes.ReactMultiSelectDropdown === val.controlType) {
        if (val.required) {
          if (
            val.selectedValueOptions &&
            val.selectedValueOptions.length === 0
          ) {
            if (val?.formsSectionID !== 3) {
              valid = true;
              newerrors[item.formId] = {
                ...newerrors[item.formId],
                [val.formsSectionID]: 'This field is required',
              };
            }

          }
        }
      }
    });
  });
  if (valid) {
    errors['dynamicForm'] = newerrors;
  }
};


export const validatePayRateInfo = (payRateType, shiftType, payRateTotalShiftAmount, payRateOccurrenceAmount, errors) => {
  if (!(+payRateType === payRateTypeObj.systemCal || +payRateType === payRateTypeObj.manualCal)) {
    errors['payRateType'] = ['Select a value.'];
  }
  if (+payRateType === payRateTypeObj.manualCal) {
    if (+shiftType === shiftTypeObj.singleShift || +shiftType === shiftTypeObj.multiShift) {
      if (!payRateTotalShiftAmount) {
        errors['payRateTotalShiftAmount'] = ['Enter a total shift amount.'];
      }
      if (+shiftType === shiftTypeObj.multiShift && !payRateOccurrenceAmount) {
        errors['payRateOccurrenceAmount'] = ['Enter a amount per shift.'];
      }
    }
  }
}